export default "__VITE_ASSET__DQD0BxiE__"